import React from 'react';

import { EUserStoreRole } from '@domain/enums/common/userStore/EUserStoreRole';

import { useStoreConfig } from '@helpers/hooks/useStoreConfig';
import { useConfig } from '@helpers/hooks/useConfig';

import { FinancialDetailsProvider } from '@helpers/hooks/pages/dashboard/financialDetails/useFinancialDetails';

import Wrapper from '@components/Dashboard/FinancialDetails/Wrapper';
import NoAccess from '@components/common/core/Utils/NoAccess';

const FinancialDetails: React.FC = () => {
  const { accessManagementData } = useStoreConfig();
  const { isInternalTeam } = useConfig();

  const isStoreOwner = accessManagementData?.role === EUserStoreRole.OWNER;
  const hasAccessToPage =
    accessManagementData?.group?.has_financial_details_table_full_write_access ||
    accessManagementData?.group?.has_financial_details_table_full_read_access;

  if (!isStoreOwner && !hasAccessToPage && !isInternalTeam) {
    return <NoAccess />;
  }

  return (
    <FinancialDetailsProvider>
      <Wrapper />
    </FinancialDetailsProvider>
  );
};

export default FinancialDetails;
